import { render, staticRenderFns } from "./ReferralTable.vue?vue&type=template&id=139972fa"
import script from "./ReferralTable.vue?vue&type=script&lang=js"
export * from "./ReferralTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports